import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  if (!to.meta?.deprecatedRoute) return
  if (!to.meta?.redirectToPath) return
  if (to.path.includes(to.meta?.redirectToPath as string)) return
  if (!Array.isArray(to.meta?.deprecatedRoute)) return
  if (!to.meta?.deprecatedRoute.includes(to.path)) return

  return navigateTo({ path: to.meta.redirectToPath as string, query: to.query })
})
